// src/config/packTemplates.js
// Migrated verbatim from prototype/between-the-lines-v2.html lines 1590-1635 (PACK_TEMPLATES)
// and line 6192 (LEGACY_PACK_ID).

export const PACK_TEMPLATES = {
    'set-text': {
        label: 'Set Text Anthology',
        description: 'Detailed analysis of fixed anthology texts',
        sidebarStructure: 'flat-list',
        tabs: ['analysis', 'flashcards', 'quizzes'],
        contentSchema: {
            title: 'string',
            author: 'string',
            coreIdea: 'string',
            outline: 'array',
            mindMap: 'object',
            themes: 'array',
            essays: 'object'
        }
    },
    'skills-workshop': {
        label: 'Skills Workshop',
        description: 'Exam technique training with units and practice',
        sidebarStructure: 'three-section',
        tabs: ['technique', 'guided', 'model', 'timed', 'cards', 'quiz', 'podcast'],
        guidedSubTabs: ['beginner', 'intermediate', 'advanced'],
        contentSchema: {
            units: 'array',
            pastPapers: 'array',
            weeklySchedule: 'object'
        }
    },
    'literature-study': {
        label: 'Literature Study',
        description: 'Comprehensive literature analysis with multi-region content',
        sidebarStructure: 'multi-region',
        contentSchema: {
            overview: 'object',
            acts: 'array',
            characters: 'array',
            themes: 'array',
            symbols: 'array',
            essays: 'array',
            practice: 'array',
            quoteBank: 'array',
            themeMatrix: 'object'
        }
    },
    'poetry-anthology': {
        label: 'Poetry Anthology',
        description: 'Poem-by-poem analysis with cross-poem comparison',
        sidebarStructure: 'multi-region',
        contentSchema: {
            overview: 'object',
            poems: 'array',
            comparison: 'object',
            practice: 'array'
        }
    },
    // Series/Bundle S1: a series is a BUNDLE of other packs (memberPackIds on the
    // /packs doc), sold as one product. It has NO content of its own -- no reader,
    // no content tabs -- so the template is deliberately empty. Registered here so
    // getPackType() returns 'series' (an unregistered type falls back to 'set-text',
    // which would route a series card into an empty set-text reader).
    'series': {
        label: 'Series (Bundle)',
        description: 'A bundle of study packs sold together as one purchase',
        sidebarStructure: 'none',
        tabs: [],
        contentSchema: {}
    }
};

export const LEGACY_PACK_ID = 'edexcel-set-text';
